// @ts-nocheck

// App
import React from 'react';
import cx from 'classnames';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

// Components
import Container from 'app/shared/core/Container';
import PagerItem from 'app/shared/modules/pager/PagerItem';
import Row from 'app/shared/core/Row';

// Misc / Utils
import controller from './controller';
import IconArrowGrey from 'images/icons/arrow-filled-grey.svg';
import IconArrowGreen from 'images/icons/arrow-filled-green.svg';
import queryUtils from 'app/shared/utils/queryUtils';
import routeUtils from 'app/shared/utils/routeUtils';
import './style.scss';

const defaultProps = {
  maxPage: 0,
  prevPage: 0,
  currPage: 0,
  nextPage: 0,
  resourceId: '#',
  searchSlug: '',
  itemsPerPage: 0,
  paginationUpperBound: 0,
  onClick: () => {},
};

class PagerContainer extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      maxPage,
      nextPage,
      currPage,
      prevPage,
      query,
      itemsPerPage,
      screenWidth,
      paginationUpperBound,
      resourceId,
      searchSlug,
    } = this.props;

    const totalPageNum = maxPage;
    const currPageNum = currPage;
    const midPagesToShow = controller.getMiddlePageNumbersToShow(currPageNum, totalPageNum, screenWidth);
    const maxVisiblePage = controller.getMaxVisiblePage(currPageNum, totalPageNum, paginationUpperBound);
    const frontDots = controller.getFrontDotsBool(currPageNum, totalPageNum, screenWidth);
    const backDots = controller.getBackDotsBool(currPageNum, totalPageNum, screenWidth);
    const isEdgePage = controller.isEdgePage;
    const url = routeUtils.buildAreaPath({ areaResourceId: resourceId, searchSlug });

    if (totalPageNum === 1) {
      return null;
    }

    return (
      <div
        className={cx('PagerContainer', {
          'PagerContainer-max-page': totalPageNum === 1,
        })}
      >
        <Container>
          <Row>
            <div className="PagerContainer-main" role="navigation" aria-label="page">
              <ul className="PagerContainer-list">
                <li className="PagerContainer-list-item PagerContainer-prev-page">
                  <PagerItem
                    maxPage={maxPage}
                    currPage={currPage}
                    itemsPerPage={itemsPerPage}
                    page={prevPage}
                    query={query}
                    url={url}
                    linkType="primary"
                  >
                    <img
                      src={isEdgePage(prevPage, maxPage) ? IconArrowGrey : IconArrowGreen}
                      className="PagerContainer-arrow-left"
                      height="12px"
                      width="12px"
                      alt=""
                    />
                    <b>{' Prev'}</b>
                  </PagerItem>
                </li>
                <li className="PagerContainer-list-item">
                  <PagerItem
                    className="PagerContainer-page-number"
                    currPage={currPage}
                    itemsPerPage={itemsPerPage}
                    maxPage={maxPage}
                    page={1}
                    query={query}
                    url={url}
                  >
                    1
                  </PagerItem>
                </li>
                {frontDots && (
                  <li className="PagerContainer-list-item" aria-hidden="true">
                    ...
                  </li>
                )}
                {midPagesToShow.map((page) => {
                  return (
                    <li key={page} className="PagerContainer-list-item">
                      <PagerItem
                        className="PagerContainer-page-number"
                        currPage={currPage}
                        itemsPerPage={itemsPerPage}
                        maxPage={maxPage}
                        page={page}
                        query={query}
                        url={url}
                      >
                        {page}
                      </PagerItem>
                    </li>
                  );
                })}
                {backDots && (
                  <li className="PagerContainer-list-item" aria-hidden="true">
                    ...
                  </li>
                )}
                {totalPageNum === 1 || maxPage === 0 ? null : (
                  <li className="PagerContainer-list-item">
                    <PagerItem
                      className="PagerContainer-page-number"
                      currPage={currPage}
                      itemsPerPage={itemsPerPage}
                      maxPage={maxPage}
                      page={maxVisiblePage}
                      query={query}
                      url={url}
                    >
                      {maxVisiblePage}
                    </PagerItem>
                  </li>
                )}
                <li className="PagerContainer-list-item PagerContainer-next-page">
                  <PagerItem
                    maxPage={maxPage}
                    currPage={currPage}
                    itemsPerPage={itemsPerPage}
                    query={query}
                    page={nextPage}
                    url={url}
                    linkType="primary"
                  >
                    <b>{'Next '}</b>
                    <img
                      src={isEdgePage(nextPage, maxPage) ? IconArrowGrey : IconArrowGreen}
                      className="PagerContainer-arrow-right"
                      height="12px"
                      width="12px"
                      alt=""
                    />
                  </PagerItem>
                </li>
              </ul>
            </div>
          </Row>
        </Container>
      </div>
    );
  }
}

PagerContainer.defaultProps = defaultProps;

const mapStateToProps = (state, ownProps) => ({
  query: queryUtils.parse(ownProps.location.search),
  resourceId: state.area.area.resourceId,
  searchSlug: state.filter.search.slug,
  screenWidth: state.app.device.screenWidth,
});
export default withRouter(connect(mapStateToProps)(PagerContainer));
